"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ScreenReaderMessage: true
};
exports.default = exports.ScreenReaderMessage = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _useAnnouncedMessage = require("../utils/_useAnnouncedMessage");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ScreenReaderMessage = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ScreenReaderMessage.css") : void 0);
var _ScreenReaderMessage2 = require("./ScreenReaderMessage.types");
Object.keys(_ScreenReaderMessage2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ScreenReaderMessage2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ScreenReaderMessage2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-screen-reader-message';
/**
 * The **ScreenReaderMessage** component provides a way to
 * programmatically expose dynamic content changes in a way
 * that can be announced by screen readers.
 *
 * It is important to note that, at this time,
 * screen readers do not inform users of alerts that are present on the page
 * before page load completes. Use the **ScreenReaderMessage** component when
 * a message is not tied to a page refresh or clicking a button that completes
 * a workflow (like submitting a form).
 *
 * See the [Patterns/Message Handling](./?path=/docs/patterns-message-handling--docs) page
 * for more detailed information on selecting the appropriate messaging component.
 */
// eslint-disable-next-line max-len
const ScreenReaderMessage = exports.ScreenReaderMessage = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(ScreenReaderMessage, _props)) : _props;
  const {
      className,
      children,
      delay = 1000,
      isAlert = false,
      onMessageAnnounced,
      announce
    } = props,
    otherProps = __rest(props, ["className", "children", "delay", "isAlert", "onMessageAnnounced", "announce"]);
  const announcedMessage = (0, _useAnnouncedMessage.useAnnouncedMessage)({
    announce,
    message: children,
    onMessageAnnounced,
    resetDelay: delay
  });
  const classnames = _bind.default.bind(_ScreenReaderMessage.default);
  const classes = classnames(CSS_BLOCK, className);
  return /*#__PURE__*/_react.default.createElement("span", Object.assign({}, otherProps, {
    className: classes,
    ref: ref,
    role: isAlert ? 'alert' : 'status'
  }), announcedMessage);
});
ScreenReaderMessage.displayName = 'ScreenReaderMessage';
ScreenReaderMessage.propTypes = {
  /** Text to read to the consumer. */
  children: _propTypes.default.string,
  /** Controls the length of the `setTimeout` delay for clearing the message from the DOM.
   * Default delay is 1000ms if this prop is not set.
   * Use milliseconds ie. `1500`
   */
  delay: _propTypes.default.number,
  /** Set `isAlert` to **true** to interrupt the user,
   * by adding `role="alert"`, which implicitly has `aria-live="assertive"`.
   *
   * This should be avoided unless absolutely necessary.
   * Consider using a **MessageDialog** or
   * **MessageView** instead.
   *
   * When `isAlert` is unset or falsy the component has `role="status"`
   * which implicitly has`aria-live="polite"` and is less aggressive.
   * */
  isAlert: _propTypes.default.bool,
  /** Custom classes to be added to the `<span>` tag.  */
  className: _propTypes.default.string,
  /** Controls whether the message (children) is rendered. This assists screen readers
   * announce a message that was not part of the DOM on page load. Use in conjunction
   * with the `onMessageAnnounced` prop.
   */
  announce: _propTypes.default.bool,
  /** Callback function when the message (children)
   * removes itself from the DOM after several seconds.
   * This assists screen readers announce a message more than
   * once when the message is identical to the last. Use in
   * conjunction with the `announce` prop.
   * */
  onMessageAnnounced: _propTypes.default.func
};
var _default = exports.default = ScreenReaderMessage;